<template>
    <div class="seller-o2o-index">
        <div class="common-header-wrap">
            <mt-header title="إعداد المتجر" class="common-header">
                <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
            </mt-header>
        </div>
      <div class="user-avatar iconfont icon-xiangji" ref="upload_btn" @change="uploadAvatar($event)">
        <img v-if="store_avatar_url" :src="store_avatar_url">
        <input type="hidden" v-model="store_avatar">
          <input type="file" accept="image/*">
      </div>
        <mt-field label="المنتجات الرئيسية" type="text" v-model="settings.store_mainbusiness" />
        <mt-field label="ف ف" type="text" v-model="settings.store_qq" />
        <mt-field label="علي وانجوانغ" type="text" v-model="settings.store_ww" />
        <mt-field label="سيو كي" type="text" v-model="settings.store_keywords" />
        <mt-field label="سيو شوب" type="text" v-model="settings.store_description" />
        <mt-field label="متجر الهاتف" type="text" v-model="settings.store_phone" />
        <mt-button class="ds-button-large" type="primary" v-on:click="submit">حفظ</mt-button>
        <mt-popup position="right" v-model="showCrop" class="crop-wrapper common-popup-wrapper">
            <div class="common-header-wrap">
                <mt-header title="قص الصورة" class="common-header">
                    <mt-button slot="left" icon="back" @click="showCrop=false"></mt-button>
                    <mt-button slot="right" @click="useCrop">استعمال</mt-button>
                </mt-header>
            </div>
            <vue-cropper class="common-popup-content" style="height: auto;position: absolute" ref="cropper" :maxImgSize="cropperOption.maxImgSize" :autoCropWidth="cropperOption.autoCropWidth" :autoCropHeight="cropperOption.autoCropHeight" :autoCrop="cropperOption.autoCrop" :img="cropperOption.img" :canMove="cropperOption.canMove" :outputType="cropperOption.outputType"></vue-cropper>
        </mt-popup>
    </div>
</template>

<script>
import { VueCropper } from 'vue-cropper'
import { uploadStoreImage, getStoreInfo, editStoreInfo } from '../../../api/sellerSetting'
import { Toast, Indicator } from 'mint-ui'
export default {
  name: 'SellerSettingInfo',
  data () {
    return {
      cropperOption: {
        img: '',
        canMove: false,
        autoCrop: true,
        autoCropWidth: 100,
        autoCropHeight: 100,
        maxImgSize: 500,
        outputType: 'png'
      },
      showCrop: false,
      store_avatar: '',
      store_avatar_url: '',
      settings: {}
    }
  },
  created: function () {
    getStoreInfo().then(res => {
      this.settings = res.result.store_info
      this.store_avatar = this.settings.store_avatar
      this.store_avatar_url = this.settings.store_avatar_url
    }).catch(function (error) {
      Toast(error.message)
    })
  },
  components: {
    VueCropper
  },
  computed: {

  },
  methods: {
    submit () {
      editStoreInfo(this.settings.store_qq, this.settings.store_ww, this.settings.store_phone, this.settings.store_mainbusiness, this.settings.store_keywords, this.settings.store_description, this.store_avatar).then(res => {
        Toast(res.message)
      }).catch(function (error) {
        Toast(error.message)
      })
    },
    uploadAvatar (event) {
      let that = this
      let file = event.target.files[0]
      let reader = new FileReader()
      let rs = reader.readAsDataURL(file)
      reader.onload = (e) => {
        that.cropperOption.img = e.target.result
        let image = new Image()
        image.src = e.target.result
        image.onload = function () {
          that.cropperOption.autoCropWidth = window.screen.width
          that.cropperOption.autoCropHeight = this.height / this.width * window.screen.width
          that.cropperOption.maxImgSize = window.screen.height - 40
          that.showCrop = true
          that.$forceUpdate()
        }
      }
    },
    useCrop () {
      this.$refs.cropper.getCropBlob(res => {
        let files = new window.File([res], 'temp.png', { type: res.type })
        let formdata = new FormData()

        formdata.append('store_avatar', files)
        formdata.append('id', 'store_avatar')
        Indicator.open()
        uploadStoreImage(formdata).then(res => {
          this.store_avatar = res.result.file_name
          this.store_avatar_url = res.result.file_path
            this.showCrop = false
            Indicator.close()
        }).catch(function (error) {
          Toast(error.message)
            Indicator.close()
        })
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.user-avatar {
      position: relative;
      width: 5rem;
      height: 5rem;
      margin: 2rem auto;
      text-align: center;
      border:1px solid #e0e0e0;
      img {
        width: 100%;
        height: 100%
      }
      input {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        opacity: 0
      }
    }
    .user-avatar::before {
      position: absolute;
      font-size: 1.5rem;
      line-height: 5rem;
      left: 50%;
      margin-left: -.75rem;
      color: rgba(0, 0, 0, 0.5)
    }
</style>
